import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import * as m from 'moment-timezone';
import { Transaction } from '../model/transaction.model';
import { RelationsService } from './relations.service';

@Injectable({
  providedIn: 'root'
})
export class FilingsService {
  query = { sort: 'Latest Buys', relation: 'All', minAmount: 0 };
  minAmount = 10000;
  LIMIT = 200;
  NUM_OF_DAYS = 7;
  filingsSubject$ = new BehaviorSubject<any>([]);
  items: Transaction[];
  priceRange = [0, 1000000000000];

  constructor(
    private relationsService: RelationsService,
    public afs: AngularFirestore
  ) { }

  init() {
    this.fetchData();

    // const ago = m().subtract('hours', 7).unix();
    // console.log('7 hours ago: ', ago);
    // const weekAgo = m().subtract('weeks', 1).unix();
    // console.log('one week ago: ', weekAgo);
  }

  updateQuery(type: string, val: string | number) {
    this.query[type] = val;
    this.filingsSubject$.next(this.filterData(this.items));
  }

  filterData(items: Transaction[]) {
    if (this.query.relation === '10% Owner') {
      items = items.filter(a => a.isTenPercentOwner === '1');
    }
    if (this.query.sort === 'Highest Last Week') {
      items = items.sort((a, b) => b.transactionValue - a.transactionValue);
    } else if (this.query.sort === 'Latest Buys') {
      items = items.sort((a, b) => b.ts - a.ts);
    }
    items = items.filter((tr) => tr.transactionValue > this.minAmount);
    items = items.filter((tr) => +tr.transactionPricePerShare >= this.priceRange[0] && +tr.transactionPricePerShare <= this.priceRange[1]);
    return items;
  }

  /*
  Sort:
    Latest Buys, Highest Last week
  Relation:
  10% Owner, All
  */

  fetchData() {
    this.afs.collection('transactions', (ref) => {
      const ago = m().subtract(this.NUM_OF_DAYS, 'days').unix();
      return ref
        .where('ts', '>', ago)
        .orderBy('ts', 'desc')
        .limit(this.LIMIT);
    })
      .valueChanges()
      .pipe(
        map(transactions => {
          transactions.map((transaction: Transaction) => {
            if (!transaction.officerTitle) {
              transaction.officerTitle = '';
            }
            transaction.relations = this.relationsService.concatRelations(transaction, 'new line');
          });
          return transactions;
        })
      )
      .subscribe((res: any) => {
        // console.log('res:', res);
        this.items = res as Transaction[];
        this.filingsSubject$.next(this.filterData(this.items));
      });
  }

  onTotalValueSliderChanged(val: number) {
    this.minAmount = val;
    this.filingsSubject$.next(this.filterData(this.items));
  }

  onPriceSliderChanged(modelRange: any) {
    this.priceRange = modelRange;
    this.filingsSubject$.next(this.filterData(this.items));
  }
}
